import { defineMessages } from 'react-intl';

export default defineMessages({
  expertiseField: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.form.expertise.form.expertise',
  },
  expertiseTitle: {
    id:
      'legal_proceeding_page.judgement_add.judgement_add_pronouncing.recap.expertise_title',
  },
});
